import * as e from "react";
import { forwardRef as o } from "react";
const a = o(function(r, t) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: t,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...r
    },
    /* @__PURE__ */ e.createElement(
      "circle",
      {
        cx: 11.5,
        cy: 11.5,
        r: 6.5,
        stroke: "currentColor",
        strokeWidth: 2
      }
    ),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M16.5 16.5L20 20",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeWidth: 2
      }
    )
  );
});
export {
  a as Search
};
